import React, {useState, useEffect} from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import ImageIcon from '@assets/icons/imageIcon';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import noColor from 'assets/pngs/noColor.png';
const PreviewGrid:React.FC<IProps> = (props, state: IState) => {
  

  const urlImage =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}/${props.brand.id}`;
  const CARD_WIDTH = 200;
  const CARD_HEIGHT = 170;
  const [logos, setLogos] = useState([]);
  const [colors, setColors] = useState([]);
  const [fonts, setFonts] = useState([]);
  const [totalLogos, setTotalLogos] = useState(0);
  const [totalColors, setTotalColors] = useState(0);
  const [totalFonts, setTotalFonts] = useState(0);
  const maxLogos = 2;
  const maxColors= 4;
  const maxFonts =1;
  
  useEffect (() => {
    let newlogos:any =[]
    if (props.brand && props.brand.logos)
    {
      props.brand.logos.map((logo:any, index: number) => {
        if (index<maxLogos)
        {
          var newLogo = {...logo};
          newlogos = [...newlogos, newLogo ];
        }      
      })
     
      setTotalLogos(props.brand.logos.length)
    }
    setLogos(newlogos)

    let newcolors:any =[]
    if (props.brand && props.brand.colors)
    {
      props.brand.colors.map((color:any, index: number) => {
        if (index<maxColors)
        {
          var newColor = {...color};
          newcolors = [...newcolors, newColor ];
        }      
      })    
      setTotalColors(props.brand.colors.length)
    }

    setColors(newcolors)

    let newfonts:any =[]

    if (props.brand && props.brand.fonts?.length)
    {
      const fontsList = props.brand.fonts.filter((item: any) => (item.status === 'ACTIVE'));
      fontsList.map((font:any, index: number) => {
        if (index<maxFonts)
        {
          var newFont = {...font};
          newfonts = [...newfonts, newFont ];
        }      
      })          
      setTotalFonts(fontsList.length)
    }
    setFonts(newfonts)

  }, [props.oem])



  return (
    <S.Root
    >
      <S.Grid style={{minHeight:"60px", padding:"0px 10px 0px 10px"}}>        
        {
          logos.length > 0 ?
           logos.map((logo:any, index:number) =>{                        
              if (logo.srcImage!==undefined){
                return (
                <S.GridImg
                  src={`${urlImage}/logos/${logo.srcImage}` + "TN"}
                  width={50}
                  height={50}
                />
                )                    
              }
              else
              {
                return (
                  <ImageIcon/>
                )
              }
          })
          :
          
            <S.GridFont>
              <S.GridFontContent>              
                0 logos
              </S.GridFontContent>
            </S.GridFont>
          
        }
        {
          totalLogos > maxLogos &&
          <S.GridLabel>
            +{totalLogos-maxLogos} 
          </S.GridLabel>
          
        }                      
      </S.Grid>
      <S.Grid>
      {
        colors.length>0 ?
        colors.map((color:any, index:number) =>{                            
            return (
            <S.GridColor
              style={{backgroundColor:color.color}}                            
            />
            )                              
        })
        :        
        <S.GridFont>
        <S.GridFontContent>              
          0 colors
        </S.GridFontContent>
      </S.GridFont>
        }
        {
        totalColors > maxColors &&
        <S.GridLabel>
        +{totalColors-maxColors} 
        </S.GridLabel>

        }
      </S.Grid>
      <S.Grid>
      {
        fonts.length>0 ?
        fonts.map((font:any, index:number) =>{
            return (
            <S.GridFont>
            <S.GridFontContent
              style={{fontFamily: `font-${font.id}`}}                            
            >           
            {font.name}
            </S.GridFontContent>
            </S.GridFont>
            )                              
        })
        :
        
           <S.GridFont>
             <S.GridFontContent>
              0 fonts
             </S.GridFontContent>
          </S.GridFont>
        
        }        
        

        {
        totalFonts > maxFonts &&
        <S.GridLabel>
        +{totalFonts-maxFonts} 
        </S.GridLabel>

        }
      </S.Grid>

    </S.Root >
  );
}

export default PreviewGrid;